import type { AssigneeDto } from "../dto/AssigneeDto";
import type { Assignee } from "@/domain/model/Assignee";
import { asPersonId } from "@/domain/model/Ids";

export const assigneeFromDto = (d: AssigneeDto): Assignee => ({
  id: asPersonId(d.personId),
  displayName: d.displayName,
  preferredName: d.preferredName ?? null,
});
